export default __webpack_public_path__ + "static/media/volunteer.501fb688.png";